import { Component, OnInit } from '@angular/core';
import { EducationService } from '../../service/education/education.service';
import { Education } from '../../class/education';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-educations',
  templateUrl: './educations.component.html',
  styleUrls: ['./educations.component.scss']
})
export class EducationsComponent implements OnInit {

    public promiseForm: Promise<any>;
    public msgs: Message[] = [];
    public education: Education[];
    public selectEducation: Education;
    public educationID: Number = 0;
    public modNew = false;
    public modView = false;
    public openEducation = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public educationPosition: string;
    public filters: {key: string, value: string}[];

    public params_id_candidate: number;

    constructor(
        public educationService: EducationService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_candidate']) {
                this.params_id_candidate = Number(params['id_candidate']);
            }
        });

        this.page = 1;
        this.per_page = 10;
        if (this.params_id_candidate) {
            this.getEducationsByCandidates(this.params_id_candidate);
        } else {
            this.getEducations();
        }
    }

    public loadEducationLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        if (this.params_id_candidate) {
            this.getEducationsByCandidates(this.params_id_candidate);
        } else {
            this.getEducations(event.globalFilter);
        }
    }

    getEducations(query?: string, filters?: any[]) {
        this.educationService.getEducation(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.education = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getEducationsByCandidates(id: number, query?: string) {
        this.educationService.getEducationByRequisition(id, this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.education = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newEducation() {
        this.modNew = !this.modNew;
        this.selectEducation = null;
    }

    public savedEducation(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectEducation = null;
        this.modNew = false;
        this.getEducations();
    }

    public cancelEducation (res) {
        this.selectEducation = null;
        this.modNew = false;
        this.modView = false;
        this.getEducations();
    }

    public edit(education: Education) {
        this.modNew = true;
        this.selectEducation = education;
        this.getEducations();
    }

    public view(education: Education) {
        this.openEducation = true;
        this.selectEducation = education;
        this.educationID = education.id;
        this.modView = true;
    }

    public deleteDialog(education: Education) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(education);
            }
        });
    }

    public delete(education: Education) {
        this.educationService.deleteEducation(education.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getEducations();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeEducation(education: Education) {
        this.putEducation(education);
    }

    public putEducation(values: Education) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.educationService.updateEducation(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/educations/educations.component.ts